import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { v4 as uuid } from 'uuid';
import { ALL_SELECTABLE_CMS_ITEMS, CmsItem } from '@coin/shared/cms/util';
import { ImageSliderComponent } from '../image-slider/image-slider.component';
import { QuoteComponent } from '../quote/quote.component';
import { PictureContainerComponent } from '../picture-container/picture-container.component';
import { CompilationComponent } from '../compilation/compilation.component';
import { NumbersComponent } from '../numbers/numbers.component';
import { SpacerComponent } from '../spacer/spacer.component';
import { TextBlockComponent } from '../text-block/text-block.component';
import { TextImageLinkComponent } from '../text-image-link/text-image-link.component';
import { HtmlEditorComponent } from '../../shared/html-editor/html-editor.component';
import { NewsHeadlineComponent } from '../news-headline/news-headline.component';
import { EquityExpandBoxComponent } from '../../equity/equity-expand-box/equity-expand-box.component';
import { EquityExpandLinksboxComponent } from '../../equity/equity-expand-linksbox/equity-expand-linksbox.component';
import { CmsButtonComponent } from '../cms-button/cms-button.component';
import { DownloadFileComponent } from '../../emails/download-file/download-file.component';
import { EmailButtonComponent } from '../../emails/email-button/email-button.component';
import { EmailQuoteComponent } from '../../emails/email-quote/email-quote.component';
import { EquityCmsChapterComponent } from '../../equity/equity-cms-chapter/equity-cms-chapter.component';
import { EquityCmsChapterOverviewComponent } from '../../equity/equity-cms-chapter-overview/equity-cms-chapter-overview.component';
import { EquityCmsCardsComponent } from '../../equity/equity-cms-cards/equity-cms-cards.component';
import { EmailSingleDoubleImageComponent } from '../../emails/email-single-double-image/email-single-double-image.component';
import { EmailVideoComponent } from '../../emails/email-video/email-video.component';
import { EquityCmsFullWidthpartWithImageComponent } from '../../equity/equity-cms-full-widthpart-with-image/equity-cms-full-widthpart-with-image.component';
import { EmailMainBodyImageTextComponent } from '../../emails/email-main-body-image-text/email-main-body-image-text.component';
import { EmailFootnotesComponent } from '../../emails/email-footnotes/email-footnotes.component';
import { LineComponent } from '../line/line.component';
import { TranslatePipe } from '@ngx-translate/core';
import { V2ButtonComponent, V2DialogFrameComponent, V2DialogFooterComponent } from '@coin/shared/core/ui-storybook';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'gmm-select-new-content',
  templateUrl: './select-new-content.component.html',
  styleUrls: ['./select-new-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    V2DialogFrameComponent,
    V2ButtonComponent,
    ImageSliderComponent,
    QuoteComponent,
    PictureContainerComponent,
    CompilationComponent,
    NumbersComponent,
    SpacerComponent,
    TextBlockComponent,
    TextImageLinkComponent,
    HtmlEditorComponent,
    NewsHeadlineComponent,
    EquityExpandBoxComponent,
    EquityExpandLinksboxComponent,
    CmsButtonComponent,
    DownloadFileComponent,
    EmailButtonComponent,
    EmailQuoteComponent,
    EquityCmsChapterComponent,
    EquityCmsChapterOverviewComponent,
    EquityCmsCardsComponent,
    EmailSingleDoubleImageComponent,
    EmailVideoComponent,
    EquityCmsFullWidthpartWithImageComponent,
    EmailMainBodyImageTextComponent,
    EmailFootnotesComponent,
    LineComponent,
    V2DialogFooterComponent,
    TranslatePipe
  ]
})
export class SelectNewContentComponent implements OnInit {
  data = inject<{
    preselection: string[];
  }>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject<MatDialogRef<SelectNewContentComponent>>(MatDialogRef);

  public viewItem?: CmsItem;
  public allSelectableItems = ALL_SELECTABLE_CMS_ITEMS;

  ngOnInit(): void {
    // The Unit-Tests doesn't know the function.
    if (this.dialogRef.updatePosition) {
      this.dialogRef.updatePosition({ left: '50vw' });
    }

    if (this.data?.preselection) {
      if (this.data?.preselection.length === 1) {
        this.dialogRef.close(this.allSelectableItems.find(itm => itm.type === this.data.preselection[0]));
      } else {
        this.allSelectableItems = this.allSelectableItems.filter(itm => this.data.preselection.indexOf(itm.type) > -1);
      }
    }
  }

  public viewThisItem(item: CmsItem): void {
    this.viewItem = undefined;
    setTimeout(() => {
      this.viewItem = item;
    });
  }

  public addThisContent(): void {
    const item: CmsItem = structuredClone(this.viewItem);
    item.id = uuid();
    this.dialogRef.close(item);
  }

  public close(): void {
    this.dialogRef.close();
  }
}
